/**
 * @desc 统一门户跳转免登接口
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 登录账号 */
  loginId?: string;
  /** 签名 */
  sign?: string;
  /** 时间戳 */
  timestamp?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/web/sso/freeLogin',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.UserModelResponse>> {
  return defHttp.get({
    url: '/mock/web/sso/freeLogin',

    params,
  });
}
